<template>
  <div class="card-info-basicas-produto-novo">
    <!-- <div class="titulo-fluxos"> INFORMAÇÕES BÁSICAS </div>
    <div class="subtitulo-fluxos"> Forneça informações básicas, como: nome, quantidade e data de carregamento </div> -->

    <g-titulo-steps
    titulo="INFORMAÇÕES BÁSICAS"
    subtitulo="Forneça informações básicas, como: nome, quantidade e data de carregamento"
    :imagemEmpresa = imagemEmpresa
    />

    <g-form>
      <div class="infoBasicas-conteudo espacamento-fluxos">
        <div class="infoBasicas-nome-produto">
          <div class="nome-produto-titulo titulo-conteudo-fluxos"> Nome do Produto <strong class="asterisco-obrigatorio">*</strong></div>
          <PInputText
          class="nome-produto-input input-label"
          maxlength="30"
          v-model="nomeProduto"
          :disabled="desativarCampoIncial || copiaOrcamentoQuantidade"
          />
        </div>

        <div class="container-quantidade-dataCarreg">
          <div class="quantidade-data-carregamento">
            <div class="infoBasicas-quantidade">
              <div class="quantidade-titulo titulo-conteudo-fluxos"> Quantidade <strong class="asterisco-obrigatorio">*</strong></div>
              <PInputNumber
              class="quantidade-input input-label"
              @keypress="camponumero"
              v-model="quantidade"
              :disabled="desativarCampoIncial"
              locale="pt-BR"
              type="int"
              :max="99_999_999"
              />
            </div>

            <div class="infoBasicas-data-carregamento">
              <div class="data-carregamento-titulo titulo-conteudo-fluxos"> Dt. de Carregamento <strong class="asterisco-obrigatorio">*</strong></div>
              <div class="botao-input-adicionar-data">
                <div class="data-carregamento">
                  <g-date-input
                  class="data-carregamento-input input-label"
                  tamanhobotao = "45px"
                  alturabotao = "40px"
                  alturainput = "42px"
                  largurainput="100%"
                  v-model="dataCarregamento"
                  :disabled="desativarCampoIncial"
                  ></g-date-input>
                </div>

                <g-button
                :class="`add-box ${(this.infoEntregaProduto.length == 2) ? 'invisivel' : ''}`"
                tipo="amarelo"
                alturainput = "42px"
                tamanhobotao = "35px"
                :disabled="desativarCampoIncial"
                tamanhoIcone="15px"
                :somenteIcone="true"
                :sombreado="false"
                @click="addRow"
               
                >
                  <i class="pi pi-minus" v-if="!ehAdicao"></i>
                  <i class="pi pi-plus" v-if="ehAdicao"></i>
                </g-button>
              </div>
            </div>
          </div>

          <div class="quantidade-data-carregamento" v-for="(data, index) in infoEntregaProduto" :key="data">
            <div class="infoBasicas-quantidade">
              <div class="quantidade-titulo titulo-conteudo-fluxos"> Quantidade </div>
              <PInputNumber
              class="quantidade-input input-label"
              v-model="infoEntregaProduto[index].quantidade"
              :disabled="desativarCampoIncial"
              @keypress="camponumero"
              type="int"
              :max="99_999_999"
              />
            </div>

            <div class="infoBasicas-data-carregamento">
              <div class="data-carregamento-titulo titulo-conteudo-fluxos"> Dt. de Carregamento </div>
              <div class="botao-input-adicionar-data">
                <div class="data-carregamento">
                  <g-date-input
                  class="data-carregamento-input input-label"
                  tamanhobotao = "45px"
                  alturabotao = "40px"
                  alturainput = "42px"
                  largurainput="100%"
                  :key="numberRow"
                  v-model="infoEntregaProduto[index].dataCarregamento"
                  :disabled="desativarCampoIncial"
                  ></g-date-input>
                </div>

                <g-button
                class="add-box"
                tipo="amarelo"
                tamanhoIcone="15px"
                :somenteIcone="true"
                :sombreado="false"
                @click="deleteRow(index)"
                v-if="!this.desativarCampoIncial"
                >
                  <i class="pi pi-minus"></i>
                </g-button>
              </div>
            </div>
          </div>
        </div>

        <div class="infoBasicas-observacao">
          <div class="observacao-titulo titulo-conteudo-fluxos"> Obs. sobre Quantidade / Carregamento / Consumo <strong class="asterisco-obrigatorio">*</strong></div>
          <PTextArea
            class="observacao-input input-label"
            rows="5"
            cols="30"
            maxlength="500"
            v-model="observacoes"
            :disabled="desativarCampoIncial"
          />
        </div>

        <div class="infoBasicas-amostraRef">
          <div class="amostraRef-titulo titulo-conteudo-fluxos"> Deseja utilizar amostra de referência? </div>
          <div class="amostra-checkbox checkbox">
            <PCheckBox
                id="acompanhaamostra"
                value="0"
                v-model="opcoesAmostraReferencia"
                @change="changeCheckboxAmostra"
                :disabled="desativarCampoIncial || copiaOrcamentoQuantidade || (opcoesAmostraReferencia.includes('0') && opcoesAmostraReferencia.includes('1'))"
              />
            <label class="amostra-titulo label-checkbox" for="amostra"> Acompanha amostra </label>
          </div>
          <div class="especificacoes-checkbox checkbox">
             <PCheckBox
                id="conformeamostra"
                value="1"
                @change="changeCheckboxEspecificacoes"
                v-model="opcoesAmostraReferencia"
                :disabled="desativarCampoIncial || copiaOrcamentoQuantidade"
              />
            <label class="especificacoes-titulo label-checkbox" for="especificacoes"> Todas as especificações técnicas conforme amostra </label>
          </div>
          <div class="outros-checkbox checkbox">
             <PCheckBox
                id="outrosmateriaischeck"
                value="2"
                v-model="opcoesAmostraReferencia"
                @change="changeCheckboxOutros"
                :disabled="desativarCampoIncial || copiaOrcamentoQuantidade"
              />
            <label class="outros-titulo label-checkbox" for="outros"> Outros materiais do cliente </label>
          </div>
          <div class="descricao-outros" v-if="contemOutros || contemAmostra">
           <PInputText
                class="input-materiais"
                placeholder="Quais materiais?"
                v-model="descricaoOutrosMateriais"
                :disabled="(desativarCampoIncial || copiaOrcamentoQuantidade)"
              ></PInputText>
          </div>
        </div>
      </div>
    </g-form>

    <PDialog :showHeader="false" :closable="false" v-model:visible="displayModalConfirmacao">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Essa solicitação se tornará orçamento somente após o recebimento da amostra </div>
      <div class="botao-popup">
        <g-button negritoTexto
        largura="200px" 
        altura="35px"
        @click="fecharDialog"
        > 
          CONFIRMAR
        </g-button>
      </div>
    </PDialog>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="step4" 
        ref="botaoContinuar"
        >
          <div v-if="escritobotao"> CONTINUAR </div>
          <div v-if="!escritobotao" class="pi pi-spin pi-spinner"></div>
        </g-button>
      </div>

      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        v-on:acao="voltarstep2" 
        >
          VOLTAR
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto 
        @click="abrePopupCancelarOrcamento"
        >
          CANCELAR
        </g-button>
      </div>
    </div>
    <PDialog :showHeader="false" :closable="false" v-model:visible="popupCancelaOrc" :modal="true">
      <div class="titulo-popup-finalizado popups-consultar-orcamentos"> Deseja cancelar esse orçamento? </div>
      <div class="botoes-popup">
        <div>
          <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="fechaPopupCancelar"
          >
            NÃO
          </g-button>
        </div>
        <div>
          <g-button
          tipo="amarelo"
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="cancelaOrcamento"
          >
            SIM
          </g-button>
        </div>
      </div>
    </PDialog>
  </div>
</template>

<script>
import InfoBasicas from "./InfoBasicas.js";
export default InfoBasicas;
</script>

<style scoped>
.espacamento-fluxos {
  margin-top: 30px;
}

.titulo-conteudo-fluxos {
  margin-top: 20px;
}

.botao-input-adicionar-data {
  display: grid;
  grid-template-columns: 8.5fr 45px;
  grid-template-rows: auto;
  grid-column-gap: 8px; 
}

.add-box {
  width: 45px;
  justify-self: self-end;
  align-self: flex-start;
}

.checkbox {
  display: flex;
  padding-top: 3px;
  padding-bottom: 3px;
}

.label-checkbox {
  color: #8a8a8a;
  text-align: left;
  font-size: 15px;
  font-family: "MontSerrat";
  margin-left: 5px;
}

.descricao-outros {
  margin-top: 10px;
}

@media (min-width: 310px) {
.infoBasicas-conteudo, .quantidade-data-carregamento {
  display: flex;
  flex-direction: column;
}
}

@media (min-width: 500px) {
.quantidade-data-carregamento {
  display: grid;
  grid-template-columns: 1.5fr 3fr;
  column-gap: 15px;
}
}

@media (min-width: 600px) {
.descricao-outros {
  width: 65%;
}
}

@media (min-width: 1025px) {
.infoBasicas-conteudo {
  display: grid;
  grid-template-columns: 50% minmax(4em, 1fr);
  grid-template-rows: repeat(2, auto);
  grid-column-gap: 20px;
}

.infoBasicas-nome-produto { grid-area: 1 / 1 / 2 / 2; }
.container-quantidade-dataCarreg { grid-area: 1 / 2 / 2 / 3; }
.infoBasicas-observacao { grid-area: 2 / 1 / 3 / 2; }
.infoBasicas-amostraRef { grid-area: 2 / 2 / 3 / 3; }

.espacamento-fluxos {
  padding: 0 30px 25px;
}
}

@media (min-width: 1200px) {
.infoBasicas-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 1fr));
}
}

@media (min-width: 1281px) {
.espacamento-fluxos {
  padding: 0 95px 25px;
}
}

@media (min-width: 1500px) {
.descricao-outros {
  width: 25em;
}

.espacamento-fluxos {
  padding: 0 15% 25px;
}
}
</style>
